import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'

import IndexView from "./Index/View"
// import DetailView from "./Detail/View"
import IndexPegawaiView from "./IndexPegawai/View"

const RouteView = (props) => {

  const queryParams = new URLSearchParams(props.location.search);
  const _create = queryParams.get('create')
  const _detail = queryParams.get('detail')
  
  const _update = queryParams.get('update')
  const _delete = queryParams.get('detail')
  const _approve = queryParams.get('approve')
  const _print = queryParams.get('print')
  const _uuid = queryParams.get('uuid')

  if (_create != null) {
    return accessRole('create') ? null : <ErrorAccess />
  } else if (_detail != null) {
    return accessRole('read') ? null : <ErrorAccess />
  } else if (_update != null) {
    return accessRole('update') ? null : <ErrorAccess />
  } else if (_delete != null) {
    return null
  } else if (_approve != null) {
    return null
  } else if (_print != null) {
    return null
  }

  // // Jika Admin
  if (accessRole('approve')) {
    return accessRole('read') ? <IndexView /> : <ErrorAccess />
  } else {
    return accessRole('read') ? <IndexPegawaiView uuid = {_uuid} /> : <ErrorAccess />
  }

  //  return accessRole('read') ? <IndexView /> : <ErrorAccess />
}
export default RouteView